import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomLabel from '@s-ui/react-atom-label'
import Context from '@s-ui/react-context'
import TableFinancingDetails from '@adv-mt/mt-table-financing-details'

import {PANEL_FINANCING_VERSION} from '../config.js'

const BASE_CLASS = 'mt-PanelFinancing'

export const PanelFinancingInfo = ({ad, isPrivate, loanCalculations, panelFinancingVersion}) => {
  const {i18n} = useContext(Context)
  const {price} = ad

  const financingDataValues = isPrivate
    ? {...loanCalculations, vehiclePrice: price}
    : {
        ...loanCalculations
      }

  const showLabel = panelFinancingVersion !== PANEL_FINANCING_VERSION.SIMPLIFIED

  return (
    <div className={`${BASE_CLASS}-info`}>
      {showLabel && <AtomLabel text={i18n.t('COMMON.OFFER_DETAILS')} />}
      <TableFinancingDetails financingData={financingDataValues} hideLegalConditionsLink={true} />
    </div>
  )
}

PanelFinancingInfo.propTypes = {
  ad: PropTypes.object,
  isPrivate: PropTypes.bool,
  loanCalculations: PropTypes.object,
  panelFinancingVersion: PropTypes.string
}
